(function($) {

    window.c24LpCssLoaded.then(function () {

        if (!$('.mod24Tarife').length) {
            return;
        }

        const tarifeTooltip = $('.mod24Tarife .tooltip');
        let prevButton = null;

        contentResizer($('.mod24TarifeBlockWrapper, .mod24TarifeVuWrapper'));

        if (tarifeTooltip.length > 0) {
            $.each(tarifeTooltip, function () {
                const trigger = $(this);
                const html = $('.mod24Tarife #tarife-tooltip-' + trigger.data('tooltip')).html();

                const extraClass = $(trigger).data('tooltip-class');

                trigger.qtip({
                    content: {
                        text: html,
                        button: (window.c24LpNotPinnedQtip ? null : 'Schließen'),
                    },
                    style: {
                        classes: 'c24Editor c24TarifePopup' + (window.c24LpNotPinnedQtip ? '' : ' closable') + (extraClass ? ' ' + extraClass : ''),
                        tip: {
                            border: 1,
                            width: 16,
                            height: 9,
                        },
                    },
                    show: {
                        event: (window.c24LpNotPinnedQtip ? 'mouseenter' : 'click focus'),
                    },
                    hide: {
                        event: (window.c24LpNotPinnedQtip ? 'mouseleave focusout' : ''),
                        fixed: true,
                        delay: 500,
                    },
                    position: {
                        viewport: $('html'),
                        // Position of the arrow
                        my: 'top center',
                        // Position relative to the parent element
                        at: 'bottom center',
                        adjust: {
                            method: 'shift flip',
                        },
                    },
                    events: {
                        render: function (event, api) {
                            window.c24OnRenderQtip(event, api);
                        },

                        move: function (event, api, position) {
                            window.c24RepositionQTip(api, position);
                        },
                    },
                });
            });
        }


        $('.c24TabButtons').each(function () {
            const tabButton = $(this);
            const tarifeContainers = $(this).parent('.mod24Tarife');
            const currentWrapper = $(this).closest('.mod24TarifeBlockWrapper, .mod24TarifeVuWrapper');
            const allContainers = $('.mod24Tarife', currentWrapper);


            $('a.c24TooltipTop', tabButton).on('click', function () {

                $('.c24TabButtons a', currentWrapper).removeClass('active');

                const allTHead = allContainers.children('thead');
                const allTBody = allContainers.children('tbody');
                const buttonName = $(this).data('button-name');
                const activeTable = tarifeContainers.filter('.' + buttonName);
                const activeTHead = $('thead', activeTable);
                const activeTBody = $('tbody', activeTable);


                currentWrapper.find('.updateDate').each(function() {

                    if ($(this).hasClass(buttonName)) {
                        $(this).addClass('active');
                    } else {
                        $(this).removeClass('active');
                    }
                });

                allTHead.hide();

                if (prevButton !== this) {
                    allTBody.removeClass('loadingTariffs').hide();
                    activeTBody.addClass('loadingTariffs').show();
                } else {
                    allTBody.hide();
                    activeTBody.show();
                }

                prevButton = this;
                activeTHead.show();

                window.setTimeout(function () {
                    activeTBody.removeClass('loadingTariffs');
                }, 500);

                $('a', tabButton).addClass('active');


                contentResizer(currentWrapper);
            });
        });

        // TRACKING tarife-vulink-clicked
        $('.tarif[data-efeedbacklink]').on('click', function () {
            const linkHref = $(this).data('efeedbacklink');
            const vu = $('.details .h3style', $(this).closest('.tarif')).text();
            let tcase = $('caption a', $(this).closest('table')).contents().get(0);


            if (tcase) {
                tcase = tcase.nodeValue.trim();
            } else {
                tcase = $(this).closest('table').data('case');
            }

            // track click on tariff link
            window._paq.push([
                'trackEvent',
                window.c24Lp.getMatomoEventCategory(),
                'tarife-vulink-clicked',
                tcase + ' - ' + vu + ' - ' + linkHref,
            ]);

            window.location.href = linkHref;
        });

        // TRACKING tarife-case-clicked
        $('.mod24Tarife caption a').on('click', function () {

            const caseName = $(this).data('button-name');
            const valueTrimmed = $(this).contents().get(0)?.nodeValue?.trim() ?? '';

            window._paq.push([
                'trackEvent',
                window.c24Lp.getMatomoEventCategory(),
                'tarife-case-clicked',
                valueTrimmed + ' - ' + caseName,
            ]);

        });

        // tarife-case-tooltip-shown
        $('.mod24Tarife caption a.c24TooltipTop').on('mouseover', function () {

            const caseName = $(this).data('button-name');
            const caseDescribe = $('.c24TooltipPopup', this).contents().text().replace(/-/g, '').trimLeft();
            const valueTrimmed = $(this).contents().get(0)?.nodeValue?.trim() ?? '';

            window._paq.push([
                'trackEvent',
                window.c24Lp.getMatomoEventCategory(),
                'tarife-case-tooltip-shown',
                valueTrimmed + ' - ' + caseName + ' - ' + caseDescribe,
            ]);
        });

        // TRACKING tarife-vu-tooltip-shown
        $('.mod24Tarife tbody .tooltip').on('mouseover', function () {

            const name = $(this).contents().get(0)?.nodeValue?.trim() ?? '';
            const vu = $('.details h3', $(this).closest('.tarif')).text();
            let tcase = $('caption a', $(this).closest('table')).contents().get(0);


            if (tcase) {
                tcase = tcase.nodeValue.trim();
            } else {
                tcase = $(this).closest('table').data('case');
            }


            window._paq.push([
                'trackEvent',
                window.c24Lp.getMatomoEventCategory(),
                'tarife-vu-tooltip-shown',
                tcase + ' - ' + vu + ' - ' + name,
            ]);
        });

        // contentresize for button flexiblity
        function contentResizer(wrapper) {

            $.each($(wrapper), function () {
                const array = [];

                $('.c24TabButtons a', this).each(function () {
                    array.push($(this).outerHeight());
                });

                const newHeight = Math.max(...array);

                if (newHeight > 50) {
                    $('.c24TabButtons a', this).css({
                        'height': newHeight,
                    });

                    $('.mod24Tarife .c24TabButtons', this).css({
                        'top': -1 * (newHeight + 10),
                    });

                    if ($('.mod24Tarife', this).length) {

                        $('.mod24Tarife', this).parent().css({
                            'marginTop': newHeight + 20,
                        });

                    } else {
                        $('.mod24Tarife', this).first().css({
                            'marginTop': newHeight,
                        });
                    }
                }
            });
        }

        $(window).resize(function () {
            contentResizer($('.mod24TarifeBlockWrapper, .mod24TarifeVuWrapper'));
        });

    });

})(window.jQuery);
